module.exports = __webpack_public_path__ + "img/logo.bf1777a3.gif";